// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.12.0",
  date: "2026-10-14T10:45:22.782Z",
  gitInfo: {
    dirty: false,
    raw: "8afcc4a4a",
    hash: "8afcc4a4a",
    distance: null,
    tag: null,
    semver: null,
    suffix: "8afcc4a4a",
    semverString: null
  }
};
/* tslint:enable */
